import Vue from 'vue'
import Vuex from 'vuex'
import { InstructionsModalApiInjection } from './InstructionsModalProvider'

Vue.use(Vuex)

export const useInstructionsStore = new Vuex.Store({
	state: {
		dialogMessage: '',
		dialogState: false
	},

	mutations: {
		showDialog(state, payload) {
			state.dialogMessage = payload
			state.dialogState = true
		},

		hideDialog(state) {
			state.dialogMessage = ''
			state.dialogState = false
		}
	}
})

export function useInstructionsModal(): InstructionsModalApiInjection {
	return {
		show: (message: string) => useInstructionsStore.commit('showDialog', message),
		hide: () => useInstructionsStore.commit('hideDialog')
	}
}
